import {localePercentWhole} from '@freckle/educator-entities/ts/common/helpers/number'
import {getAssessmentAnswersStats} from '@freckle/educator-entities/ts/math/assessment/logic/assessments'
import type {AssessmentAnswerT} from '@freckle/educator-entities/ts/math/assessment/models/assessment-answer'
import type {MathQuestionMapT} from '@freckle/educator-entities/ts/math/common/models/questions'
import {H2, H4} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {
  overallResultWrapper,
  overallResult,
  accuracyCardHeader,
  accuracyCard,
  accuracyCardBody,
} from './overall-result.module.scss'

type Props = {
  assessmentAnswers: Array<AssessmentAnswerT>
  questionMap: MathQuestionMapT
}

export default function OverallResult(props: Props) {
  const {t} = useSafeTranslation()
  const {assessmentAnswers, questionMap} = props

  const {accuracy} = getAssessmentAnswersStats(assessmentAnswers, questionMap)
  const accuracyNode =
    accuracy !== undefined && accuracy !== null
      ? localePercentWhole(Math.round(accuracy))
      : t('ASSESSMENT_REPORT_OVERALL_ACCURACY_NOT_STARTED_TEXT')

  return (
    <div className={overallResultWrapper}>
      <div className={overallResult}>
        <div className={accuracyCard}>
          <div className={accuracyCardHeader}>
            <H4>{t('ASSESSMENT_REPORT_OVERALL_ACCURACY_SECTION_TITLE')}</H4>
          </div>
          <div className={accuracyCardBody}>
            <H2>{accuracyNode}</H2>
          </div>
        </div>
      </div>
    </div>
  )
}
